import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "antd";
import { TagsOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import CategoryForm from "./form";

export default function CategoryUpdate() {
  const { id } = useParams();
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Categories", path: "/billing/categories" },
          { label: "Edit", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <TagsOutlined /> }}
        title="Edit Category"
        style={{ marginBottom: 16 }}
      />
      <CategoryForm id={id} />
    </div>
  );
}
